export default __webpack_public_path__ + "static/media/korean.2b4d800b.svg";